module.exports = __webpack_public_path__ + "img/31@2x.378ef81.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/cooperation/31@2x.png
// module id = bLHU
// module chunks = 0